import React, { useState } from "react";
import { connect } from "react-redux";
import { Col, Button, Row, Card } from "reactstrap";
import { BlockPlaceholder } from "../Components";
import { translate } from "../../utils/i18n";

import { bindActionCreators } from "redux";
import * as CounterDashboardActions from "../../redux/actions/CounterDashboardActions";

import Select from "react-select";

const CountersOrganizationSelector = props => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  // eslint-disable-next-line 
  const handleOrgnizationSelection = selectedOrganization => {
    if (props.selectedOrganization !== selectedOrganization) props.setSelectedOrganization(selectedOrganization);
  };
  return (
    <Card className={isCollapsed ? "px-0 my-4 " : "px-0 my-4 shadow-sm"}>
      {props.hasOwnProperty("organizations") && props.organizations.length > 0 && (
        <React.Fragment>
          <div
            className={
              isCollapsed
                ? "shadow-sm organization-wrapper py-3 d-flex justify-content-between "
                : "organization-wrapper py-3 d-flex justify-content-between "
            }
          >
            <div
              className="pl-3 h3 pointer"
              onClick={() => {
                setIsCollapsed(!isCollapsed);
              }}
            >
              {translate("organizations")}
            </div>
            <Button
              color="link"
              className="pull-left  pointer"
              onClick={() => {
                setIsCollapsed(!isCollapsed);
              }}
            >
              <i className={isCollapsed ? "fa fa-plus mr-1 lead" : "fa fa-minus mr-1 lead"} />
            </Button>
          </div>

          {!isCollapsed &&
            (props.organizations.length ? (
              <div className="mx-4 mb-4">
                <Row>
                  {/* <Col xs="12">
                  <TESTDEVCOMP />
                </Col> */}

                  <Col xs="12">
                    <Select
                      name="organizationOptions"
                      placeholder={translate("pleaseSelectOrganization")}
                      value={props.selectedOrganization}
                      onChange={props.handleOrgnizationSelection}
                      isClearable={props.isClearable || false}
                      isMulti={false}
                      options={props.organizations}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      disabled={props.isFetchingGroups}
                    />
                  </Col>
                </Row>
              </div>
            ) : (
              <Row>
                <Col xs={12}>
                  <BlockPlaceholder height={"200"} />
                </Col>
              </Row>
            ))}
        </React.Fragment>
      )}
    </Card>
  );
};
const mapStateToProps = state => ({
  isFetchingGroups: state.devicesReducer.isFetchingGroups,
  language: state.i18nReducer.language,
  organizations: state.CounterDashboardReducer.organizations,
  selectedOrganization: state.CounterDashboardReducer.selectedOrganization,
  isNoDeviceSelected: state.devicesReducer.isNoDeviceSelected
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...CounterDashboardActions }, dispatch);
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CountersOrganizationSelector);
